<template>
  <div>
    <v-dialog v-model="dialog" persistent max-width="600px">
      <v-card>
        <v-card-title class="justify-center">{{
          $t("payment.paymentConfirmation")
        }}</v-card-title>

        <v-divider></v-divider>
        <br />

        <v-card-text class="text-center">
          <v-spacer></v-spacer>

          <span>
            {{ $t("payment.paymentRequest") }}
            <br />
            <strong
              style="margin-top: 10px; text-transform: uppercase; font-size: large;"
              >{{ formatPrice(amount) }}</strong
            >?
          </span>
          <br />
          <span>
            con {{ paymentMode === "datafono" ? "Datafono" : "Efectivo" }}
          </span>
          <v-spacer></v-spacer>
          <v-btn
            @click="closeDialog"
            color="light"
            text
            style="margin-top: 10px; height: 50px; width: 50px;font-size: 50px"
          >
            <font-awesome-icon
              icon="times-circle"
              :style="{ color: '#ea2222', fontSize: 50 }"
            />
          </v-btn>

          <v-btn
            @click="confirmPayment"
            color="light"
            text
            :disabled="paymentMode === null"
            style="margin-top: 10px; height: 50px; width: 50px;font-size: 50px;"
          >
            <font-awesome-icon
              icon="check-circle"
              :style="{ color: '#11bd11', fontSize: 50 }"
            />
          </v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>
    <FacturaDialog ref="facturaDialogRef" />
  </div>
</template>

<script>
import FacturaDialog from "./FacturaDialog.vue";
//import CashOrDatafono from "@/components/public/receipt/CashOrDatafono";

export default {
  components: { FacturaDialog },
  name: "CashPaymentDialog",
  data() {
    return {
      amount: 0,
      paymentType: "amount",
      dialog: false,
      selectedProducts: [],
      paymentMode: null
    };
  },
  methods: {
    openDialog(amount = 0, canBeDivide, selectedProducts, paymentMode) {
      this.amount = amount;
      this.paymentType = canBeDivide;
      this.dialog = true;
      this.selectedProducts = selectedProducts;
      this.paymentMode = paymentMode;
    },
    closeDialog() {
      this.dialog = false;
    },
    confirmPayment() {
      this.$refs.facturaDialogRef.openDialog(
        this.amount,
        this.paymentType,
        this.selectedProducts,
        this.paymentMode
      );
      this.closeDialog();
    }
  }
};
</script>

<style></style>
